import React from "react";
import Dialog from "@material-ui/core/Dialog";
import styles from "./style.module.css";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import InputAdornment from "@material-ui/core/InputAdornment";
import Table from "../../../views/Table/Table.js";
import axios from "axios";
import TopBar from "../../utils/Topbar/TopBar.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import VisibilityRoundedIcon from "@material-ui/icons/VisibilityRounded";
import Tooltip from "@material-ui/core/Tooltip";

import ProductInventory from "./ProductInventory/ProductInventory";
import PartInventory from "./partInventory/PartInventory";
import DownloadInventory from "./DownloadInventory";

const Inventory = (props) => {
  const [data, setData] = React.useState(false);
  const [filteredData, setFilteredData] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [warehouse, setWarehouse] = React.useState(false);
  const [activeProduct, setActiveProduct] = React.useState(false);
  const [partInventoryModal, setPartInventoryModal] = React.useState(false);

  React.useEffect(() => {
    axios({
      // url: "/getProductListInWarehouse",
      url: "/fetchWarehouseSummary",
      method: "post",
      data: {
        userId: props.user._id,
        warehouseId: props.value._id,
      },
    })
      .then((res) => {
        console.log('Network Response');
        console.log(res);
        if (Object.keys(res.data.data).length > 0) {
          setData(res.data.data.finalResponse);
          setFilteredData(res.data.data.finalResponse);
          setWarehouse(res.data.data.warehouse);
        } else {
          setData("NO_DATA");
        }
      })
      .catch((err) => {
        console.log(err);
        props.setAlert("Something went wrong try again");
        props.onClose();
      });
  }, []);

  React.useEffect(() => {
    if (data) {
      let arr = {};
      Object.keys(data).forEach((key) => {
        let val = data[key];
        let objType = val.objectType;
        let name = objType =="Product"? val.objectId.productName:val.objectId.partName;
        if (
          name
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        ) {
          arr[key] = val;
        }
      });
      setFilteredData({ ...arr });
    }
  }, [searchValue]);

  // let parts = [];
  // data && data != "NO_DATA" && data.forEach(val => {
  //     val.product && parts.push([
  //         val.product.productName,
  //         val.product.product_barcode,
  //         val.category ? val.category.categoryName : "Nan",
  //         val.product.weight,
  //         val.quantity,

  //         <Tooltip title="View Parts">
  //             <IconButton onClick={() => setActiveProduct(val)}>
  //                 <VisibilityRoundedIcon />
  //             </IconButton>
  //         </Tooltip>
  //     ])
  // })

  const isLoading = !data && !filteredData;
  const noData = data == "NO_DATA";
  const showData = !isLoading && !noData;

  const details = [];
  !isLoading &&
    filteredData &&
    Object.keys(filteredData).forEach((key) => {
      let val = filteredData[key];
      console.log(filteredData[key]);
      let item = val.objectId;
      console.log('Item');
      console.log(item);
      details.push([
        // val.product.productName,
        // val.product.product_barcode,
        // val.product.categories ? val.product.categories.categoryName : "Nan",
        // val.product.weight,
        // val.quantity,
        val.objectType == 'Product' ? item.productName: item.partName,
        val.objectType == 'Product' ? item.product_barcode:item.parts_barcode,
        val.objectType == 'Product' && item.categories ? item.categories.categoryName: '',
        val.warehouseStock,
        val.bookedStock,
        val.balanceStock,

        <Tooltip title="View Parts">
          <IconButton onClick={() => setActiveProduct(val)}>
            <VisibilityRoundedIcon />
          </IconButton>
        </Tooltip>,
      ]);
    });

  return (
    <React.Fragment>
      {activeProduct && (
        <ProductInventory
          value={activeProduct}
          warehouse={warehouse}
          warehouseId={props.value._id}
          onClose={() => setActiveProduct(false)}
          setPartInventoryModal={(val) => setPartInventoryModal(val)}
        />
      )}

      {partInventoryModal && (
        <PartInventory
          value={partInventoryModal}
          onClose={() => setPartInventoryModal(false)}
          user={props.user}
          setAlert={(msg) => props.setAlert(msg)}
          warehouse={props.value}
        />
      )}

      <Dialog
        open={props.value}
        onClose={props.onClose}
        scroll={"paper"}
        maxWidth={"lg"}
        fullWidth={true}
      >
        <div className={styles.container}>
          <div className={styles.containerContent}>
            <div className={styles.header}>
              <h1>Warehouse Inventory</h1>
              <div style={{ justifyContent: "flex-end" }}>
                {showData && (
                  <DownloadInventory details={details} name={warehouse} />
                )}
                <IconButton onClick={props.onClose}>
                  <CloseRoundedIcon />
                </IconButton>
              </div>
            </div>

            {noData && (
              <div className={styles.loader}>
                <h4>Warehouse does not have any inventory</h4>
              </div>
            )}

            {showData && (
              <div className={styles.content}>
                <h2>Warehouse Detail</h2>
                <Table
                  tableHeaderColor="primary"
                  tableHead={[
                    "Name",
                    "Bar Code",
                    "Address",
                    "Location",
                    "Contact Number",
                  ]}
                  tableData={[
                    [
                      warehouse ? warehouse.name : "Nan",
                      warehouse ? warehouse.warehouse_barcode : "Nan",
                      warehouse ? warehouse.address : "Nan",
                      warehouse ? warehouse.warehouseLocation : "Nan",
                      warehouse ? warehouse.contactNum : "Nan",
                    ],
                  ]}
                />
                <div className={styles.alignItem}>
                  <h2>Product Details</h2>

                  {/* <DownloadInventory /> */}
                  <TextField
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    variant="outlined"
                    color="primary"
                    label="Search Here"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchRoundedIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <Table
                  tableHeaderColor="primary"
                  tableHead={[
                    "Product Name",
                    "Product Code",
                    "Category",
                    "Warehouse Stock",
                    "Booked Stock",
                    "Balance Stock",
                    "Part locations",
                  ]}
                  tableData={details}
                />
              </div>
            )}

            {isLoading && (
              <div className={styles.loader}>
                <CircularProgress />
              </div>
            )}
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default Inventory;
